<div class="menu-indice"><a routerLink="../../../gestionparticipantefirma/{{a_tipo}}/{{c_constancia}}">Volver a Listado de {{x_tipo}}</a> / {{x_titulo}} </div>
  <mdb-card>
    <mdb-card-body style="background-color: rgb(248, 248, 248);" >
    <div style="text-align: center; align-items: center; width: 100%; " *ngIf="esunitario">
        <div class="interno" style="width: 700px;">
          <pdf-viewer [src]="pdfSource" [original-size]="false"></pdf-viewer>
        </div>
      <br>
    </div>
    <div  style="text-align: center; align-items: center; width: 100%; ">
      <form ngNoForm class="bit4id-sign" action="{{serverSubir}}SingOk?id=1&tipo={{a_tipo}}&idc={{c_constancia}}&idp={{c_id}}" method="post" enctype='multipart/form-data'>
         <div class="bit4id-signReq" style="display: none;">
           <div class="bit4id-document">{{pdfRutaApi}}</div>
           <div class="bit4id-documentName">{{fileName}}</div>
           <div class="bit4id-documentID">{{fileName}}</div>
           <div class="bit4id-signatureType">PAdES</div>
           <div class="bit4id-signingAlgorithm">RSASHA256</div>
           <div class="bit4id-certInfo">CN</div>
           <div class="bit4id-bundle">{{bundle}}</div>
           <div class="bit4id-page">0</div>
           <div class="bit4id-image">{{image}}</div>
           <div class="bit4id-preview">YES</div>
           <div class="bit4id-editpagepos">YES</div>
           <div class="bit4id-localfile">NO</div>
           <div class="bit4id-position">{{position}}</div>
           <div class="bit4id-paragraphFormat">[&#123; "font" : ["Universal",12], "align":"right", "data_format":&#123;"timezone":"America/Lima", "strtime":"%d.%m.%Y  %H:%M:%S%z"&#125;,"format": ["Firmado digitalmente por :", "$(CN)s", "Fecha: $(date)s", ]&#125;]</div>
         </div>
         <div>
           <fieldset>
              <div id = "bit4id-status"> </div>
              <div class="linkfirma"  style="width: 200px;">
                  <input type="submit" value="{{valor_boton}}" disabled name="cmd" />
              </div>
           </fieldset>
         </div>
      </form>
    </div>
    </mdb-card-body>
  </mdb-card>
